import { defineMessages } from "react-intl";

export const messages = defineMessages({
  referenceTypesTitle: {
    id: "UvZuf7",
    defaultMessage: "Reference Types",
    description: "section title for reference types selector",
  },
  noProductTypesAssigned: {
    id: "M3aMq+",
    defaultMessage: "No product types assigned",
    description: "empty state for reference types",
  },
  noModelTypesAssigned: {
    id: "4DkQt1",
    defaultMessage: "No model types assigned",
    description: "empty state for model types",
  },
  referenceTypesHelp: {
    id: "COWJSG",
    defaultMessage:
      "Assigning reference types narrows the list of items this attribute can reference.",
    description: "helper explaining the effect of assigning reference types",
  },
});
